import './Root.scss';
import Component from './Root.js';
export default Component;